import { focusFirst } from './ViewletTitleBarMenuBarFocusFirst.js'

export const handleKeyHomeMenuClosed = focusFirst
